import { Component, Injector } from '@angular/core';
import { environment } from "../../../environments/environment";
import { _Object, GetObjectTaggingCommand, HeadObjectCommand, ListObjectsV2Command, S3Client } from "@aws-sdk/client-s3";
import { S3File, S3FileTag } from "../../../models/s3file";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { S3Connector } from '../S3Connector';

@Component({
  selector: 'app-virtex-assets',
  templateUrl: './virtex-assets.component.html',
  styleUrls: ['./virtex-assets.component.css']
})
export class VirtexAssetsComponent extends BaseComponent {
  private readonly s3Client: S3Client
  private s3Connector: S3Connector;

  extractFolderArray: any = []
  metaFiles: any = []; // All files in meta/ folder
  textureFiles: any = []; // All texture files in meta/ folder
  groundFiles: any = []; // All ground files in meta/ folder
  groundHeightFiles: any = []; // All ground height files in meta/ folder
  skyboxFiles: any = []; // All skybox files in meta/ folder
  glbFiles: any = []; // All glb files in assets/ folder

  folders: { name: string, fileCount: number }[] = []; // List of folders in meta/ with file counts
  folderFiles: { [folderName: string]: S3File[] } = {}; // Files for each folder
  loadedFolders: { [folderName: string]: boolean } = {}; // Track which folders have been loaded
  expandedFolders: { [folderName: string]: boolean } = {}; // Track which folders are expanded
  showingImages: { [folderName: string]: boolean } = {}; // Track which folders are showing images

  // Modal properties for file preview
  showFileModal: boolean = false;
  selectedFile: S3File | null = null;
  selectedFileGlbSize: number | null = null;
  bucketName: string = environment.virtexAssets.bucket;

  // Search functionality properties
  searchTerm: string = '';
  searchResults: any[] = [];
  searchLoading: boolean = false;
  searchPerformed: boolean = false;

  // Asset info visibility toggle
  showAssetInfo: boolean = true;
  showInfoBox: boolean = true;
  
  // Consistency check results
  showConsistencyResults: boolean = false;
  consistencyResults: {
    glbFileCount: number,
    metaFileCount: number,
    glbWithoutImages: string[],
    imagesWithoutGlb: string[]
  } | null = null;
  
  s3Files: any[] = [];


  constructor(private injector: Injector) {
    super(injector)
    this.s3Connector = new S3Connector(injector);
  }

  async ngOnInit(): Promise<void> {
    console.log('ngOnInit - this:', this);
    console.log('ngOnInit - this.db:', this.db);
    console.log('ngOnInit - this.loader:', this.loader);

    this.loader.show()
    await this.s3Connector.init();
    
    // Assign properties from S3Connector
    this.s3Files = this.s3Connector.s3Files;
    this.metaFiles = this.s3Connector.metaFiles;
    this.glbFiles = this.s3Connector.glbFiles;
    this.textureFiles = this.s3Connector.textureFiles;
    this.groundFiles = this.s3Connector.groundFiles;
    this.groundHeightFiles = this.s3Connector.groundHeightFiles;
    this.skyboxFiles = this.s3Connector.skyboxFiles;
    this.folders = this.s3Connector.folders;
    this.folderFiles = this.s3Connector.folderFiles;
    this.loadedFolders = this.s3Connector.loadedFolders;
    this.extractFolderArray = this.s3Connector.extractFolderArray;

    console.log('API Response - s3Files:', this.s3Files);
    console.log('API Response - metaFiles:', this.metaFiles);
    console.log('API Response - extractFolderArray:', this.extractFolderArray);
    console.log('API Response - folders:', this.folders);
    console.log('API Response - folderFiles:', this.folderFiles);
    console.log('API Response - textureFiles:', this.textureFiles);
    console.log('API Response - groundFiles:', this.groundFiles);
    console.log('API Response - groundHeightFiles:', this.groundHeightFiles);
    console.log('API Response - skyboxFiles:', this.skyboxFiles);
    console.log('API Response - glbFiles:', this.glbFiles);
    // await this.listFolders()
    this.loader.hide()
  }
  private extractFileName(file: any): string {
    const key = file.key as string;
    const fileTemp = key.substring(key.lastIndexOf('/') + 1);
    const fileNameWithoutExtension = fileTemp.replace(/\.[^/.]+$/, "");
    return fileNameWithoutExtension;
  }





  private transformKeyToGlb(key: string) {
    // Extract the file name without the folder paths
    const fileName = key.substring(key.lastIndexOf('/') + 1)
    // Replace the file extension with .glb
    return fileName.replace(/\.[^/.]+$/, '.glb')
  }

  private extractFolderFromKey(key: string): string {
    // Extract folder name from key like "meta/foldername/filename.ext"
    const parts = key.split('/');
    if (parts.length >= 2 && parts[0] === 'meta') {
      return parts[1];
    }
    return 'unknown';
  }



  getFolderNameForFile(file: S3File): string {
    return this.extractFolderFromKey(file.Key);
  }

  getTotalFileCount(): number {
    return this.folders.reduce((total, folder) => total + folder.fileCount, 0);
  }

  toggleAssetInfo(): void {
    this.showAssetInfo = !this.showAssetInfo;
  }

  async checkConsistency(): Promise<void> {
    this.loader.show();

    try {
      // Use local arrays instead of S3 API calls
      const metaFileNames = new Set(this.metaFiles.map((file: any) => file.fileName));
      const glbFileNames = new Set(this.glbFiles.map((file: any) => file.fileName));

      // Find GLB files without corresponding images
      const glbWithoutImages: string[] = Array.from(glbFileNames).filter(name => !metaFileNames.has(name)) as string[];

      // Find image files without corresponding GLB files
      const imagesWithoutGlb: string[] = Array.from(metaFileNames).filter(name => !glbFileNames.has(name)) as string[];

      // Store results and show the box
      this.consistencyResults = {
        glbFileCount: glbFileNames.size,
        metaFileCount: metaFileNames.size,
        glbWithoutImages,
        imagesWithoutGlb
      };
      
      // Close info box and show consistency results
      this.showInfoBox = false;
      this.showConsistencyResults = true;

    } catch (error) {
      console.error('Error during consistency check:', error);
      alert('Error performing consistency check: ' + error);
    } finally {
      this.loader.hide();
    }
  }

  private async getAllMetaFiles(): Promise<string[]> {
    const bucketName = environment.virtexAssets.bucket;
    const allFiles: string[] = [];

    try {
      const response = await this.s3Client.send(new ListObjectsV2Command({
        Bucket: bucketName,
        Prefix: "meta/"
      }));

      if (response.Contents) {
        // Filter out directories and get only image files
        const files = response.Contents
          .filter(obj => !obj.Key?.endsWith('/') && obj.Key)
          .map(obj => obj.Key!)
          .filter(key => this.isImageFile(key));

        allFiles.push(...files);
      }
    } catch (error) {
      console.error('Error listing meta files:', error);
      throw error;
    }

    return allFiles;
  }

  private async getAllGlbFiles(): Promise<string[]> {
    const bucketName = environment.virtexAssets.bucket;
    const allFiles: string[] = [];

    try {
      const response = await this.s3Client.send(new ListObjectsV2Command({
        Bucket: bucketName,
        Prefix: "assets/"
      }));

      if (response.Contents) {
        // Filter out directories and get only GLB files
        const files = response.Contents
          .filter(obj => !obj.Key?.endsWith('/') && obj.Key)
          .map(obj => obj.Key!)
          .filter(key => key.toLowerCase().endsWith('.glb'));

        allFiles.push(...files);
      }
    } catch (error) {
      console.error('Error listing GLB files:', error);
      throw error;
    }

    return allFiles;
  }

  private getBaseName(filePath: string): string {
    // Extract filename from path and remove extension
    const fileName = filePath.split('/').pop() || filePath;
    return fileName.replace(/\.[^/.]+$/, ''); // Remove extension
  }
  private generateDownloadUrl(key: string): string {
    return `${environment.virtexAssets.downloadUrl}/${key}`
  }

  private generateBucketUrl(bucketName: string, key: string): string {
    return `${environment.virtexAssets.bucketUrl}/${bucketName}?region=${environment.virtexAssets.region}&bucketType=general&prefix=${key}`
  }

  private excludeDirectories(files: _Object[]): _Object[] {
    return files.filter(file => {
      let isDirectory = file.Key?.endsWith('/');
      return !isDirectory;
    })
  }


  async onFileClick(file: any): Promise<void> {
    const fileKey = file.key || file.Key; // Support both formats
    if (this.isImageFile(fileKey)) {
      // Generate download URL for the file
      file.DownloadUrl = `https://virtex-v2.cellpodium.com/${fileKey}`;
      // Ensure GLBFile is set
      if (!file.GLBFile) {
        file.GLBFile = this.transformKeyToGlb(fileKey);
      }
      this.selectedFile = file;

      // Use locally cached glbSize if available, otherwise query S3
      if (file.glbSize) {
        this.selectedFileGlbSize = file.glbSize;
      } else {
        await this.getGlbFileSize(file.GLBFile);
      }

      this.showFileModal = true;
    }
  }

  async getGlbFileSize(glbFileName: string): Promise<void> {
    try {
      const glbKey = `assets/${glbFileName}`;
      const headCommand = new HeadObjectCommand({
        Bucket: this.bucketName,
        Key: glbKey
      });

      const response = await this.s3Client.send(headCommand);
      this.selectedFileGlbSize = response.ContentLength || null;
    } catch (error) {
      console.error(`Error getting GLB file size for ${glbFileName}:`, error);
      this.selectedFileGlbSize = null;
    }
  }

  closeFileModal(): void {
    this.showFileModal = false;
    this.selectedFile = null;
    this.selectedFileGlbSize = null;
  }

  isImageFile(filename: string): boolean {
    if (!filename) return false;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.tiff']
    const lowercasedFilename = filename.toLowerCase()
    return imageExtensions.some(extension => lowercasedFilename.endsWith(extension))
  }

  protected readonly environment = environment;

  getSizeFormatted(size: number): string {
    const megabytes = size / (1024 * 1024)
    if (megabytes < 1) {
      const kilobytes = size / 1024
      return `${kilobytes.toFixed(2)} KB`
    } else {
      return `${megabytes.toFixed(2)} MB`
    }
  }

  isFolderLoaded(folderName: string): boolean {
    return this.loadedFolders[folderName] === true;
  }

  isFolderExpanded(folderName: string): boolean {
    return this.expandedFolders[folderName] === true;
  }

  isFolderShowingImages(folderName: string): boolean {
    return this.showingImages[folderName] === true;
  }

  async showFolderImages(folderName: string): Promise<void> {
    // Load files if not already loaded (already loaded from backend in this case)
    if (!this.loadedFolders[folderName]) {
      return;
    }

    // Generate download URLs and GLB filenames for image files
    if (this.folderFiles[folderName]) {
      this.folderFiles[folderName].forEach((file: any) => {
        const fileKey = file.key || file.Key;
        if (this.isImageFile(fileKey) && !file.DownloadUrl) {
          file.DownloadUrl = `https://virtex-v2.cellpodium.com/${fileKey}`;
          file.Key = fileKey; // Ensure uppercase Key property exists for compatibility
          file.Size = file.size; // Ensure uppercase Size property exists for compatibility
          file.glbSize = this.getGLBSize(file)
          if (!file.GLBFile) {
            file.GLBFile = this.transformKeyToGlb(fileKey);
          }
        }
      });
    }

    this.showingImages[folderName] = true;
    this.expandedFolders[folderName] = true; // Also expand the folder
  }

  private getGLBSize(file: any): number {
    let result = 0;
    let glbFile = this.glbFiles.find((glb: any) => glb.fileName === file.fileName);
    if (glbFile) {
      result = glbFile.size;
    }
    return result;
  }

  hasFiles(folderName: string): boolean {
    return this.folderFiles[folderName] && this.folderFiles[folderName].length > 0;
  }

  async toggleFolder(folderName: string): Promise<void> {
    // Toggle expanded state
    this.expandedFolders[folderName] = !this.expandedFolders[folderName];
    
    // If expanding and images not yet shown, enrich the files with image URLs
    if (this.expandedFolders[folderName] && !this.showingImages[folderName]) {
      if (this.folderFiles[folderName]) {
        this.folderFiles[folderName].forEach((file: any) => {
          const fileKey = file.key || file.Key;
          const isImage = this.isImageFile(fileKey);
          // Always set Key so the template never gets undefined
          file.Key = fileKey;
          file.Size = file.size || file.Size;
          if (isImage && !file.DownloadUrl) {
            file.DownloadUrl = `https://virtex-v2.cellpodium.com/${fileKey}`;
            file.glbSize = this.getGLBSize(file)
            if (!file.GLBFile) {
              file.GLBFile = this.transformKeyToGlb(fileKey);
            }
          }
        });
        this.showingImages[folderName] = true;
      }
    }
  }

  async searchFiles(): Promise<void> {
    if (!this.searchTerm || this.searchTerm.trim().length === 0) {
      return;
    }

    this.searchLoading = true;
    this.searchResults = [];
    this.searchPerformed = false;

    try {
      // Search in metaFiles array
      const searchTermLower = this.searchTerm.toLowerCase();
      
      this.searchResults = this.metaFiles
        .filter((file: any) => {
          const fileName = file.fileName || file.GLBFile || this.extractFileName(file);
          return fileName.toLowerCase().includes(searchTermLower);
        })
        .map((file: any) => {
          const fileKey = file.key || file.Key;
          const folderName = this.s3Connector.extractNthFolderFromPath(fileKey, 2);
          
          return {
            key: fileKey,
            Key: fileKey,
            Size: file.size || file.Size,
            GLBFile: file.GLBFile || this.transformKeyToGlb(fileKey),
            fileName: file.fileName,
            FolderName: folderName,
            DownloadUrl: `https://virtex-v2.cellpodium.com/${fileKey}`,
            glbSize: this.getGLBSize(file)
          };
        });

      console.log(`Search found ${this.searchResults.length} files containing "${this.searchTerm}"`);
      this.searchPerformed = true;
    } catch (error) {
      console.error('Error searching files:', error);
    } finally {
      this.searchLoading = false;
    }
  }
}
